module.exports = __webpack_public_path__ + "img/60287114.30ed2174.png";